import { SelectOptionProps, TabPanel, TabsLayout } from '@televet/kibble-ui';
import React from 'react';
import { PaymentMedium } from 'shared/types/graphql';
import { InvoiceStatus } from 'shared/providers/StripeTerminalProvider';
import TerminalPayment from './TerminalPayment';
import ManualPayment from './ManualPayment';
import { defaultCardValidationState } from '.././utils/paymentEnumsAndVariables';
import { StripeCardElementChangeEvent } from '@stripe/stripe-js';
import { IOption } from 'shared/components/Dropdown';

interface ITabsWrapperProps {
  tabIndex: number;
  handleTabsChange: (index: number) => void;
  currentPaymentMedium: PaymentMedium;
  terminalOptions: IOption[] | undefined;
  terminalOption: IOption | undefined;
  terminalMenuItems: SelectOptionProps[] | undefined;
  currentInvoiceStatus: InvoiceStatus;
  syncTerminalList: () => void;
  isInitialized: boolean;
  selectTerminalOption: (selectedItem: SelectOptionProps | undefined) => void;
  isValid: typeof defaultCardValidationState;
  selectedSavedPaymentMethodStripeId: string | null;
  setSelectedSavedPaymentMethodStripeId: React.Dispatch<React.SetStateAction<string | null>>;
  isCardSetForSaving: boolean;
  setIsCardSetForSaving: (isCardSetForSaving: boolean) => void;
  handleChangeCreditCard: (e: StripeCardElementChangeEvent) => void;
  validationMessage: string;
  clinicPetParentId: string;
}

const TabsWrapper = ({
  tabIndex,
  handleTabsChange,
  currentPaymentMedium,
  terminalOption,
  terminalOptions,
  terminalMenuItems,
  currentInvoiceStatus,
  syncTerminalList,
  isInitialized,
  selectTerminalOption,
  isValid,
  selectedSavedPaymentMethodStripeId,
  setSelectedSavedPaymentMethodStripeId,
  isCardSetForSaving,
  handleChangeCreditCard,
  setIsCardSetForSaving,
  validationMessage,
  clinicPetParentId,
}: ITabsWrapperProps): JSX.Element => {
  return (
    <TabsLayout
      index={tabIndex}
      onChange={handleTabsChange}
      isFitted
      pt="2"
      tabList={[{ label: 'Terminal' }, { label: 'Manual' }]}
      tabPanels={[
        <TabPanel key="terminal-payment">
          <TerminalPayment
            currentPaymentMedium={currentPaymentMedium}
            terminalOptions={terminalOptions}
            terminalOption={terminalOption}
            terminalMenuItems={terminalMenuItems}
            currentInvoiceStatus={currentInvoiceStatus}
            syncTerminalList={syncTerminalList}
            isInitialized={isInitialized}
            selectTerminalOption={selectTerminalOption}
          />
        </TabPanel>,
        <TabPanel key="manual-payment">
          <ManualPayment
            currentPaymentMedium={currentPaymentMedium}
            isValid={isValid}
            selectedSavedPaymentMethodStripeId={selectedSavedPaymentMethodStripeId}
            setSelectedSavedPaymentMethodStripeId={setSelectedSavedPaymentMethodStripeId}
            isCardSetForSaving={isCardSetForSaving}
            handleChangeCreditCard={handleChangeCreditCard}
            setIsCardSetForSaving={setIsCardSetForSaving}
            validationMessage={validationMessage}
            clinicPetParentId={clinicPetParentId}
          />
        </TabPanel>,
      ]}
    />
  );
};

export default TabsWrapper;
